const Info = (message: any) => {
    // tslint:disable-next-line:no-console
    console.log(message);
};

const Exception = (err: Error) => {
    // tslint:disable-next-line:no-console
    console.error(err.message, err);
};

const Logger = {
    Info,
    Exception,
};

export default Logger;
